import React, { useContext, useEffect, useState } from 'react';
import {
  getInstitutions,
  getInstitutionsType,
  getInstitutionByTypeId,
  updateSubjects,
  deleteSubjects,
  deleteAuthorizedPersons,
  getInstitutionSubjectsById,
  getSubjects,
  getLanguagesType,
} from '../../../actions';
import { Context } from '../../../defaults';
import { SubjectsAdd } from './SubjectsAdd';
import { SubjectsTable2 } from './SubjectsTable2';
import {
  Tabs,
  TreeSelect,
  Row,
  Col,
  Select,
  Empty,
  Form,
  Input,
  Card,
  Descriptions,
  Popconfirm,
  Tooltip,
  Switch,
  message,
  Dropdown,
  Menu,
  Button
} from 'antd';
import {
  CarryOutTwoTone,
  DeleteTwoTone,
  EditTwoTone,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { groupBy } from '../../../utils';
//import '../authorizedpersons/index.css';
import { studyYearRegex, schoolYearRegex } from '../../../common';

const { TabPane } = Tabs;
const { TreeNode } = TreeSelect;

const Subjects = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [active, setActive] = useState('1');
  const [added, setAdded] = useState(false);
  const [subjects, setSubjects] = useState();
  const [languagesType, setLanguagesType] = useState();
  const [subjectsList, setSubjectsList] = useState();
  const [isTopicChange, setIsTopicChange] = useState(false);
  const [institutions, setInstitutions] = useState();
  const [institutionsList, setInstitutionsList] = useState();
  const [selectedInstitutionType, setSelectedInstitutionType] = useState();
  const [institutionsType, setInstitutionsType] = useState();
  const [groupedInstitutions, setGroupedInstitutions] = useState({});
  const [selectedInstitution, setSelectedInstitution] = useState();
  const [edit, setEdit] = useState(false);
  const requiredMessage = dictionary?.FillTheField[language];

  const [selectedSubjects, setSelectedSubjects] = useState();

  const onSelectInstitution = (value) => {
    setSelectedInstitution(institutions.filter((x) => x.id == value)[0]);
    getInstitutionSubjectsById(value).then(({ data }) => setSubjectsList(data));
  };

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  const filterInstitutionsByTypeId = (id) => {
    setLoading(true);
    getInstitutionByTypeId(id).then((res) => {
      setSelectedInstitutionType(id);
      setGroupedInstitutions(groupBy(res.data, 'city'));
      setInstitutions(res.data);
      setLoading(false);
    });
  };

  const saveEditedSubjects = () => {
    if (
      selectedSubjects.name &&
      selectedSubjects.description &&
      selectedSubjects.langId &&
      selectedSubjects.yearOfStudy &&
      selectedSubjects.institutionId &&
      selectedSubjects.studyYear
    ) {
      setEdit(false);
      updateSubjects(selectedSubjects)
        .then((res) => {
          console.log(selectedSubjects);
          filterInstitutionsByTypeId(selectedInstitutionType);
          getInstitutionSubjectsById(selectedSubjects.institutionId).then(({ data }) =>
            setSubjectsList(data),
          );
          message.success(dictionary?.SuccessfullyChanged[language]);
        })
        .catch(() => {
          setLoading(false);
          message.error(dictionary?.SomethingWentWrong[language]);
        });
    } else {
      message.error(dictionary?.FillTheAllRequiredFields[language]);
    }
  };

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    setSelectedSubjects({ ...selectedSubjects, [name]: value });
  };
  const onChange = ({ name, value }) => {
    setSelectedSubjects({ ...selectedSubjects, [name]: value });
  };

  const confirm = () => {
    deleteAuthorizedPersons(selectedSubjects.id).then((res) => {
      message.success(dictionary?.OperationSuccessful[language]);
      setSelectedInstitution(null);
      setSelectedSubjects(null);

      filterInstitutionsByTypeId(selectedInstitutionType);
    });
  };

  const rules = (value, name = '') => {
    if (name === 'studyYear') {
      if (!selectedSubjects.studyYear.match(schoolYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.SchoolStudyYear[language] };
      } else {
        return { validateStatus: 'success', help: null };
      }
    } else if (name === 'yearOfStudy') {
      if (!selectedSubjects.yearOfStudy.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      } else {
        return { validateStatus: 'success', help: null };
      }
    } else if (!value)
      return { validateStatus: 'error', help: dictionary?.RequiredField[language] };
    else return { validateStatus: 'success', help: null };
  };

  useEffect(() => {
    getSubjects().then(({ data }) => { 
      setSubjects(data)
    } );
    getInstitutions().then(({ data }) => {
      setInstitutions(data);
      setInstitutionsList(data);
    });
    getInstitutionsType().then(({ data }) => setInstitutionsType(data));
    getLanguagesType().then(({ data }) => setLanguagesType(data));
  }, []);

  return (
    <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.AddSubject[language]}`} key="1">
        <SubjectsAdd
          setAdded={setAdded}
          setActive={setActive}
          subjects={subjects}
          languagesType={languagesType}
          institutions={institutionsList}
        />
      </TabPane>
      <TabPane tab={dictionary?.SubjectsList[language]} key="2">
        <div style={{ marginTop: 24 }}>
          <SubjectsTable2 added={added} institutions={institutionsList} />
        </div>
      </TabPane>
      
      {/* <TabPane tab={dictionary?.SubjectsList[language]} key="2">
        <Row style={{ marginTop: '30px' }} gutter={16}>
          <Col span={8}>
            <Select
              placeholder={dictionary?.InstitutionType[language]}
              size="large"
              style={{ width: '100%' }}
              allowClear={true}
              onChange={(value) => filterInstitutionsByTypeId(value)}>
              {institutionsType &&
                institutionsType.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {el.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
          <Col span={8}>
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              size="large"
              disabled={!selectedInstitutionType}
              value={selectedInstitution?.id}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder={dictionary?.SelectInstitutionOrSearch[language]}
              allowClear
              treeDefaultExpandAll
              onChange={onSelectInstitution}
              filterTreeNode={(search, item) => {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              }}>
              {groupedInstitutions &&
                Object.keys(groupedInstitutions).map((key) => {
                  return (
                    <TreeNode title={key} key={`city${key}`} disabled>
                      {groupedInstitutions[key].map((value) => {
                        return <TreeNode value={value.id} title={value.name} />;
                      })}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
          </Col>
          <Col span={8}>
            <Select
              placeholder={dictionary?.Subjects[language]}
              size="large"
              style={{ width: '100%' }}
              allowClear={true}
              disabled={!selectedInstitution}
              value={selectedSubjects?.id}
              filterOption={(search, item) => {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              }}
              onChange={(value) => setSelectedSubjects(subjectsList.find((i) => i.id === value))}>
              {subjectsList &&
                subjectsList.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {el.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
        </Row>
        {!selectedInstitution && <Empty style={{ marginTop: '100px' }} />}
        {selectedSubjects && (
          <Card
            style={{ marginTop: '30px' }}
            actions={[
              <Tooltip placement="top" title={dictionary?.Delete[language]}>
                <Popconfirm
                  placement="bottom"
                  title={dictionary?.AreYouSureToDelete[language]}
                  onConfirm={confirm}
                  okText={dictionary?.Yes[language]}
                  cancelText={dictionary?.No[language]}>
                  <DeleteTwoTone key="delete" twoToneColor="#eb2f96" />
                </Popconfirm>
              </Tooltip>,
              <Tooltip placement="top" title={dictionary?.Edit[language]}>
                {!edit && <EditTwoTone key="edit" onClick={() => setEdit(true)} />}
                {edit && <CarryOutTwoTone key="edit" onClick={saveEditedSubjects} />}
              </Tooltip>,
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      onClick={() => {
                        setSelectedSubjects(id);
                        setIsTopicChange(true);
                      }}>
                      {dictionary?.ChangeTopicsList[language]}
                    </Menu.Item>
                  </Menu>
                }
                placement="bottomLeft">
                <Button>{dictionary?.More[language]}</Button>
              </Dropdown>,
            ]}>
            <Descriptions
              size="default"
              title={dictionary?.EditSubject[language]}
              bordered
              column={12}>
              <Descriptions.Item label={dictionary?.Name[language]} span={12}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedSubjects.name)}>
                    <TextArea
                      style={{ width: '100%' }}
                      size="middle"
                      name="name"
                      onChange={onInputChange}
                      maxLength={100}
                      value={selectedSubjects.name}
                      showCount={true}
                      placeholder={dictionary?.Name[language]}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedSubjects && selectedSubjects.name}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.Description[language]} span={12}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedSubjects.description)}>
                    <TextArea
                      style={{ width: '100%' }}
                      size="middle"
                      name="description"
                      onChange={onInputChange}
                      maxLength={100}
                      value={selectedSubjects.description}
                      showCount={true}
                      placeholder={dictionary?.Description[language]}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedSubjects && selectedSubjects.description}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.Language[language]} span={12}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedSubjects.langId, 'langId')}>
                    <Select
                      style={{ width: '100%' }}
                      placeholder={dictionary?.Lang[language]}
                      name="langId"
                      onChange={(value) => onChange({ name: 'langId', value })}
                      size="middle"
                      value={selectedSubjects.langId}
                      allowClear={true}>
                      {languagesType &&
                        languagesType.map((el) => {
                          return (
                            <Select.Option value={el.id} key={el.id}>
                              {el.name}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                )}
                {!edit &&
                  selectedSubjects.langId &&
                  languagesType.filter((el) => el.id === selectedSubjects.langId)[0].name}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.StudyYear[language]} span={12}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedSubjects.studyYear, 'studyYear')}>
                    <Input
                      style={{ width: '100%' }}
                      size="middle"
                      name="studyYear"
                      value={selectedSubjects.studyYear}
                      placeholder={dictionary?.StudyYear[language]}
                      onChange={onInputChange}
                    />
                  </Form.Item>
                )}
                {!edit && selectedSubjects.studyYear}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.YearStudy[language]} span={12}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedSubjects.yearOfStudy, 'yearOfStudy')}>
                    <Input
                      style={{ width: '100%' }}
                      size="middle"
                      name="yearOfStudy"
                      value={selectedSubjects.yearOfStudy}
                      placeholder={dictionary?.YearStudy[language]}
                      onChange={onInputChange}
                    />
                  </Form.Item>
                )}
                {!edit && selectedSubjects.yearOfStudy}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )}
      </TabPane> */}
    
    
    </Tabs>
  );
};
export default Subjects;
